import React from 'react';
import { Stack, Box, Grid, Radio, InputAdornment, IconButton, Typography, Tooltip, Checkbox, TablePagination } from '@mui/material';
import { StyledCard, StyledCardTitle, FlexDiv, CustomSearch, TableBadge, CustomCheckbox } from '../../../../../../../custom/components';
import { DeleteIcon, AddIcon, } from '../../../../../../../custom/constants';
import styles from '../../../../../../../custom/style.module.css';
import importStyles from './consignee.module.css';
import ConsigneeDetails from './ConsigneeDetails';
import { Search, CheckCircle } from '@mui/icons-material';
import WarningIcon from  '../../../../../../../assets/images/actionIcons/warning.svg';
import MailBounceIcon from '../../../../../../../assets/images/actionIcons/emailBounce.svg';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';
import moment from 'moment';

const Consignee = (props) => {

  const { consigneeFields, handleOpen, onDelteConsignee, filteredData } = props;

  const consigneeColumns = [
    {
      id: 'select',
      accessorKey: 'select',
      header: (<Typography color='transparent'>-</Typography>),
      cell: ({ row }) => {
        return <Radio size='small' className={styles.p0}
          checked={consigneeFields?.id === row?.original.id}
          onChange={() => {
            handleOpen('consignee', 'edit', row.original);
          }}
        />;
      },   
    },
    {
      id: 'name',
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <Typography variant='inherit' sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          maxWidth: '200px' 
        }}>
          {row.original.name}
        </Typography>
      ),
    },
    {
      id: 'updatedByUser',
      accessorKey: 'updatedByUser',
      header: 'Last Updated By',
      cell: ({ row }) => {
        return row.original.updatedByUser || (row.original.contactName ? `${row.original.contactName} (External)` : '-') ;
      },
    },
    {
      id: 'last_updated_on',
      accessorKey: 'last_updated_on',
      header: 'Last Updated On',
      cell: ({ row }) => {
        return <span>{row.original.updatedAt ? moment(row.original.updatedAt).format('DDMMMYY hh:mm').toUpperCase() : '-'}</span>;
      },   
    },
    {
      id: 'status-icons',
      accessorKey: 'mails',
      header: 'Status',
      enableSorting: false,
      size: 60,
      cell: ({ row }) => {
        const failedMailsCount = (row.original.mails ? row.original.mails.filter(m => !m.deleted && m.failed).length : 0) + (row.original.email_failed ? 1 : 0);
        return (
          <Stack direction='row' spacing={2} alignItems='center' justifyContent='center'>
            {row.original.verification_status === 'pending' && (
              <Tooltip title='Awaiting info registration' arrow>
                <div className={importStyles.warningIconWrapper}>
                  <img src={WarningIcon} alt='warning' width='100%' height='100%' />
                </div>
              </Tooltip>
            )}
            {row.original.verification_status === 'completed' && (
              <Tooltip title='Registration completed' arrow>
                <CheckCircle sx={{
                  color: '#4caf50',
                  fontSize: '20px' 
                }} />
              </Tooltip>
            )}
            {failedMailsCount > 0 && (
              <Tooltip title={`${failedMailsCount} email(s) bounced`} arrow>
                <TableBadge badgeContent={failedMailsCount} color='error'>
                  <img src={MailBounceIcon} alt='Mail Bounce Icon' height={'auto'} width={20} />
                </TableBadge>
              </Tooltip>
            )}
          </Stack>
        );
      }
    },
    {
      id: 'action',
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={styles.actionIcons}>
            {/* <EditIcon onClick={() => { handleOpen('consignee', 'edit', row.original); }} /> */}
            <DeleteIcon type='button' onClick={(e) => { onDelteConsignee(row.original.id, e.target); }} />
          </Stack>
        );
      }
    },
  ];

  return (
    <div>
      <Grid container direction={'row'} spacing={3}>
        <Grid item xs={12} lg={8}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>Consignee</StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={4} alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-24px'}>
              <CustomCheckbox
                control={
                  <Checkbox
                    checked={props.filter?.bounce === 'bounced'}
                    onChange={(e) => {
                      props.onChangeFilter({
                        target: {
                          name: 'bounce',
                          value: e.target.checked ? 'bounced' : 'ALL'
                        }
                      });
                    }}
                    size='small'
                    color='primary'
                  />
                }
                label='Show Bounced Emails'
              />
              <CustomSearch
                id='search'
                variant='outlined'
                size='small'
                type='search'
                placeholder='Search'
                name='search'
                className={`${styles.brInput} ${importStyles.consigneeSearch}`}
                value={props?.filter?.search || ''}
                onChange={props.onChangeFilter}
                onClick={(e) => e.stopPropagation()}
                InputProps={{
                  classes: { input: importStyles.consigneeSearchInput },
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.filterData}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.filterData();
                    }
                  }
                }
              />
              <AddIcon className={styles.addIcon} title='Add Consignee' 
                onClick={() => handleOpen('consignee', 'add')} 
              />
            </Stack>
            <Box className={`${styles.TStableWrapper} ${importStyles.consigneeTableOuter}`}>
              <TableWrapper columns={consigneeColumns} data={filteredData} />
            </Box>
            <TablePagination
              component='div'
              count={props.totalItems || 0}
              page={(props.page || 1) - 1}
              onPageChange={(e, newPage) => props.onPageChange(newPage + 1)}
              rowsPerPage={props.limit || 25}
              onRowsPerPageChange={(e) => props.onRowsPerPageChange(parseInt(e.target.value, 10))}
              rowsPerPageOptions={[10, 25, 50, 100]}
              className={importStyles.consigneePagination}
            />
          </StyledCard>
        </Grid>
        <Grid item xs={12} lg={4}>
          <ConsigneeDetails
            action={props.action}
            consigneeFields={props.consigneeFields}
            consigneeFieldsErrors={props.consigneeFieldsErrors}
            onChangeConsignee={props.onChangeConsignee}
            addConsignee={props.addConsignee}
            editConsignee={props.editConsignee}
            onClose={props.onClose}
            onAddCMail={props.onAddCMail}
            onChangeCMail={props.onChangeCMail}
            onDeleteCMail={props.onDeleteCMail}
            submitting={props.submitting}
            requestingUpdate={props.requestingUpdate}
            onRequestInfoUpdate={props.onRequestInfoUpdate}
          />
        </Grid>

      </Grid>
    </div>
  );
};

export default Consignee;